module.exports = __webpack_public_path__ + "img/gsf-logo.fbc6e420.jpg";